import { FC, ReactNode } from 'react';

import { Table, TableColumnsType, TableProps } from 'antd';

import { ESourceRelationStatuses } from 'entities/Offer';
import { ISourceRelation } from 'entities/Offer/model/types';
import { getJoinedSource } from 'entities/Source';

interface DataType {
	key: React.Key;
	name: ReactNode;
	status: ReactNode;
	comment: ReactNode;
}

interface IJoinedSourcesProps extends TableProps<DataType> {
	sources: ISourceRelation[];
	offer: string;
}

export const JoinedSources: FC<IJoinedSourcesProps> = ({ sources, offer, ...props }) => {
	const columns: TableColumnsType<DataType> = [
		{
			dataIndex: 'name',
			key: 'name',
		},
		{
			dataIndex: 'status',
			key: 'status',
		},
		{
			dataIndex: 'comment',
			key: 'comment',
		},
	];

	const dataSource = sources
		.filter(({ status }) => status !== ESourceRelationStatuses.DISABLED)
		.map<DataType>((source, i) => {
			return getJoinedSource(source, offer, i);
		});

	return (
		<Table<DataType>
			{...props}
			showHeader={false}
			columns={columns}
			dataSource={dataSource}
			bordered={false}
			scroll={{ x: 'max-content' }}
			pagination={false}
			showSorterTooltip={false}
		/>
	);
};
